import { Controller } from 'stimulus'

export default class extends Controller {
  checkAll(event) {
    const checkAllTrigger = event.currentTarget

    const tableBody = this.element.closest('table').querySelector('tbody')
    const checkboxes = tableBody.querySelectorAll('input[type=checkbox]')

    checkboxes.forEach((checkbox) => {
      checkbox.checked = checkAllTrigger.checked
    })
  }
}
